import React, { useState } from "react";
import { Button, Card, Col, Form, Input, Modal, Row, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import Post from "../services/Post";
import Cropper from "react-easy-crop";

const AddStudent = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const parent = location.state?.parent; // Handle undefined state
  const [imageBase64, setImageBase64] = useState("");
  const [processing, setProcessing] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // const normFile = (e, setFile) => {
  //   console.log("Upload event:", e);

  //   const fileList = Array.isArray(e) ? e : e?.fileList;
  //   const file = fileList?.[fileList.length - 1]?.originFileObj;

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => {
  //       const base64String = reader.result.split(",")[1];
  //       console.log("Base64:", base64String);
  //       setFile(base64String);
  //     };
  //   }

  //   return file ? [file] : [];
  // };

  // Function to handle image conversion to Base64
  const handleImageUpload = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setImageSrc(reader.result);
      setModalVisible(true); // Open crop modal
    };
    return false; // Prevent automatic upload
  };

  const onCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const cropAndSaveImage = async () => {
    if (!imageSrc || !croppedAreaPixels) return;

    const croppedBase64 = await getCroppedImg(imageSrc, croppedAreaPixels);
    const base64String = croppedBase64.split(",")[1]; // Extract base64 data
    setImageBase64(base64String);
    setModalVisible(false);
  };

  const getCroppedImg = (imageSrc, cropArea) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 120;
        canvas.height = 120;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
          image,
          cropArea.x,
          cropArea.y,
          cropArea.width,
          cropArea.height,
          0,
          0,
          120,
          120
        );

        resolve(canvas.toDataURL("image/webp")); // Return cropped base64
      };
    });
  };

  // Function to handle form submission
  const handleFormSubmit = (values) => {
    const studentData = {
      ...values,
      profile: imageBase64, // Add Base64 image to form data
      parent_id: parent?.id || null, // Ensure it handles cases with no parent data
    };
    setProcessing(true);

    console.log("New Student Data:", studentData);

    Post.AddStudent(studentData)
      .then((res) => {
        console.log(res);
        if (res.error) {
          message.error(res.error);
        } else {
          // Store the updated user data in localStorage
          // message.success("Member created successfully!");
          message.success("Student added successfully!");
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setProcessing(false);
      });

    form.resetFields();
    setImageBase64(""); // Reset the image field
  };

  return (
    <div className="layout-content">
      <Row justify="center">
        <Col span={6}>
          <Card>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleFormSubmit}
              style={{ maxWidth: 400 }}
            >
              {/* Student Name */}
              <Form.Item
                name="name"
                label="Student Name"
                rules={[
                  { required: true, message: "Please enter student name" },
                ]}
              >
                <Input placeholder="Enter student name" />
              </Form.Item>

              {/* Student Class */}
              <Form.Item
                name="class"
                label="Student Class"
                rules={[
                  { required: true, message: "Please enter student class" },
                ]}
              >
                <Input placeholder="Enter student class" />
              </Form.Item>

              {/* Student Section */}
              <Form.Item
                name="section"
                label="Student Section"
                rules={[
                  { required: true, message: "Please enter student section" },
                ]}
              >
                <Input placeholder="Enter student section" />
              </Form.Item>

              <Form.Item
                name="admission_no"
                label="Admission Number"
                rules={[
                  {
                    required: true,
                    message: "Please enter student admission number",
                  },
                ]}
              >
                <Input placeholder="Enter student admission number" />
              </Form.Item>

              {/* Profile Picture Upload */}
              <Form.Item label="Profile Picture">
                <Upload
                  accept="image/*"
                  beforeUpload={handleImageUpload}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />}>
                    Upload Profile Picture
                  </Button>
                </Upload>

                {imageBase64 && (
                  <img
                    src={`data:image/webp;base64,${imageBase64}`}
                    alt="Profile Preview"
                    style={{
                      marginTop: 10,
                      width: 120,
                      height: 120,
                      borderRadius: 8,
                    }}
                  />
                )}

                {/* Cropper Modal */}
                <Modal
                  open={modalVisible}
                  onCancel={() => setModalVisible(false)}
                  onOk={cropAndSaveImage}
                  title="Crop Image"
                >
                  <div
                    style={{ position: "relative", width: "100%", height: 300 }}
                  >
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                  </div>
                </Modal>
              </Form.Item>

              {/* Submit Button */}
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  loading={processing}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddStudent;
